module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('h1', {
    staticClass: "toc-title"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }, [_vm._v("Contents")])]), _c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "id": "page_7"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007_Introduction#fm-1"
    }
  }, [_vm._v("Introduction")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-fm"
  }, [_c('a', {
    attrs: {
      "href": "#/008_Abbreviation#fm-2"
    }
  }, [_vm._v("Abbreviations")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "href": "#/009_Part01#pt-1"
    }
  }, [_vm._v("Part 1: Background Questions About the “Historical” Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('a', {
    attrs: {
      "href": "#/010_Section1A#tocsec-1"
    }
  }, [_vm._v("A: Questions Related to the Quest for the Historical Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/011_Chapter01#ch-1"
    }
  }, [_vm._v("1."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Is at Stake Regarding the Four Gospels?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/012_Chapter02#ch-2"
    }
  }, [_vm._v("2."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Do the Gospels Present an Accurate Description of the Life of Jesus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('a', {
    attrs: {
      "href": "#/013_Chapter03#ch-3"
    }
  }, [_vm._v("3."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Were the First Two Quests for the Historical Jesus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/014_Chapter04#ch-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("4."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Is the Third Quest for the Historical Jesus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/015_Chapter05#ch-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("5."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Are the Various Views of the Historical Jesus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section1"
  }, [_c('span', {
    attrs: {
      "href": "#/016_Section1B#tocsec-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B: Questions Related to the Sources of the Historical Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/017_Chapter06#ch-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("6."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Does the Old Testament Teach About the Coming Messiah?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/018_Chapter07#ch-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("7."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Is Jesus’ Life Confirmed by Non-Jewish and Jewish Sources?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/019_Chapter08#ch-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("8."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Are the Apocryphal Gospels a Reliable Source of the Historical Jesus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap"
  }, [_c('span', {
    attrs: {
      "href": "#/020_Chapter09#ch-9",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("9."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Was the Oral Tradition Regarding the Historical Jesus Reliable?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/021_Chapter10#ch-10",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("10."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Does the NT (Outside the Gospels) Teach About Jesus’ Life and Teaching?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/022_Chapter11#ch-11",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("11."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Do We Learn About the Historical Jesus from Archaeology?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/023_Part02#pt-2",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 2: Questions About Jesus’ Birth and Childhood")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/024_Section2A#tocsec-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A: Questions Related to the Birth of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/025_Chapter12#ch-12",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("12."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("When Was Jesus Born?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/026_Chapter13#ch-13",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("13."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Was Jesus Really Born of a Virgin?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/027_Chapter14#ch-14",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("14."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Why Does It Matter That Jesus Was Born of a Virgin?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/028_Chapter15#ch-15",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("15."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Did Isaiah 7:14 Predict That Jesus Would Be Born of a Virgin?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section1"
  }, [_c('span', {
    attrs: {
      "href": "#/029_Section2B#tocsec-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B: Questions Related to the Childhood of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/030_Chapter16#ch-16",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("16."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Did Jesus Have Brothers and Sisters?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/031_Chapter17#ch-17",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("17."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Was Jesus’ Family Rich or Poor?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/032_Chapter18#ch-18",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("18."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Did Jesus Do Miracles as a Child?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/033_Chapter19#ch-19",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("19."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Language(s) Did Jesus Speak?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('a', {
    attrs: {
      "id": "page_8"
    }
  }), _c('span', {
    attrs: {
      "href": "#/034_Part03#pt-3",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 3: Questions About Jesus’ Life and Teaching")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/035_Section3A#tocsec-5",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A: Questions Related to the Life of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/036_Chapter20#ch-20",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("20."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Why Are There Four Different Accounts of Jesus’ Life?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/037_Chapter21#ch-21",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("21."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("When Did Jesus Begin His Earthly Ministry?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/038_Chapter22#ch-22",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("22."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Did the Baptism of Jesus Signify?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/039_Chapter23#ch-23",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("23."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Is the Significance of Jesus’ Temptations in the Wilderness?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/040_Chapter24#ch-24",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("24."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Who Were the Twelve Disciples, and Why Did Jesus Choose Twelve?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/041_Chapter25#ch-25",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("25."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Does It Mean That Jesus Was Transfigured?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/042_Chapter26#ch-26",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("26."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Did Jesus Really Perform Miracles as an Adult?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section1"
  }, [_c('span', {
    attrs: {
      "href": "#/043_Section3B#tocsec-6",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B: Questions Related to the Teaching of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/044_Chapter27#ch-27",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("27."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Was the Focus of Jesus’ Teaching?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/045_Chapter28#ch-28",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("28."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Is the Main Message of Matthew About Jesus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/046_Chapter29#ch-29",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("29."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Is the Main Message of Mark About Jesus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/047_Chapter30#ch-30",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("30."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Is the Main Message of Luke About Jesus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/048_Chapter31#ch-31",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("31."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Is the Main Message of John About Jesus?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/049_Chapter32#ch-32",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("32."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Did the Historical Jesus Say About His Return (in the Olivet Discourse)?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-part"
  }, [_c('span', {
    attrs: {
      "href": "#/050_Part04#pt-4",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Part 4: Questions About Jesus’ Crucifixion and Resurrection")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section"
  }, [_c('span', {
    attrs: {
      "href": "#/051_Section4A#tocsec-7",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("A: Questions Related to the Crucifixion of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/052_Chapter33#ch-33",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("33."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Is the Significance of the Triumphal Entry?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/053_Chapter34#ch-34",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("34."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("When and Why Did Jesus Cleanse the Temple?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/054_Chapter35#ch-35",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("35."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Who Was Responsible for Jesus’ Death?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/055_Chapter36#ch-36",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("36."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Why Did Jesus Die?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/056_Chapter37#ch-37",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("37."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Did Jesus Remain in the Tomb Three Days and Three Nights?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/057_Chapter38#ch-38",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("38."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Where Did Jesus’ Spirit Go While His Body Was in the Tomb?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-section1"
  }, [_c('span', {
    attrs: {
      "href": "#/058_Section4B#tocsec-8",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("B: Questions Related to the Resurrection of Jesus")])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/059_Chapter39#ch-39",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("39."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("Did the Historical Jesus Rise from the Dead?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-chap1"
  }, [_c('span', {
    attrs: {
      "href": "#/060_Chapter40#ch-40",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("40."), _c('span', {
    staticClass: "toc"
  }, [_vm._v("What Is the Meaning of Jesus’ Ascension?")])])]), _vm._v(" "), _c('p', {
    staticClass: "toc-bm"
  }, [_c('span', {
    attrs: {
      "href": "#/061_Bibliography#bm-1",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Select Bibliography")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7c55e195","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/006_Contents.vue
// module id = 72
// module chunks = 0